import { useLocation } from "react-router-dom";
import { useMobileShell } from "../../context/useMobileShell.js";
import { ROUTES } from "../../constants/routes.js";
import "./MobileTopBar.css";

const TITLE_BY_PATH = {
  [ROUTES.HOME]: "Home",
  [ROUTES.TASK]: "Task",
  [ROUTES.TEMPLATES]: "Templates",
  [ROUTES.PROJECTS]: "Projects",
  [ROUTES.TRIGGERS]: "Triggers",
  [ROUTES.RELICS]: "Relics",
  [ROUTES.MEMORY]: "Memory",
  [ROUTES.KNOWLEDGE_CONFIG]: "Knowledge",
  [ROUTES.SETTINGS]: "Settings",
};

function titleForPath(pathname) {
  if (TITLE_BY_PATH[pathname]) return TITLE_BY_PATH[pathname];
  // Prefix match for nested paths (/templates/:id, /new-task/:taskId, etc.)
  const prefix = Object.keys(TITLE_BY_PATH).find(
    (p) => p !== "/" && pathname.startsWith(`${p}/`),
  );
  return prefix ? TITLE_BY_PATH[prefix] : "HarmonIQ";
}

export default function MobileTopBar() {
  const { toggleDrawer, isDrawerOpen } = useMobileShell();
  const { pathname } = useLocation();
  const title = titleForPath(pathname);

  return (
    <header className="mobile-topbar" role="banner">
      <button
        type="button"
        className="mobile-topbar-burger"
        aria-label={isDrawerOpen ? "Close menu" : "Open menu"}
        aria-expanded={isDrawerOpen}
        aria-controls="app-sidebar"
        onClick={toggleDrawer}
      >
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <line x1="4" y1="7" x2="20" y2="7" />
          <line x1="4" y1="12" x2="20" y2="12" />
          <line x1="4" y1="17" x2="20" y2="17" />
        </svg>
      </button>

      <div className="mobile-topbar-title" title={title}>
        {title}
      </div>

      {/* Reserved slot mirroring the burger so the title stays optically
          centered. Phase 2 surfaces the run-status indicator here so a
          live task stays visible with the drawer closed. */}
      <div className="mobile-topbar-right" aria-hidden="true" />
    </header>
  );
}
